/*
  "Make it a set" cart drawer upsell — click handling.

  Rather than relying on the drawer-quickbuy component's own opener
  binding (which only scans for .js-drawer-quickbuy elements once at
  page load and won't see buttons injected later when the cart drawer
  re-renders via AJAX), this uses a single document-level delegated
  click listener. That works regardless of when the button enters the
  DOM, so no rebind step is needed after cart updates.

  Clicking "Add" opens the theme's existing quickbuy drawer (same one
  used elsewhere in the theme for quick-add with size selection) for
  the companion product, exactly as if its own opener had been
  clicked.
*/
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-make-it-a-set-quickbuy');
    if (!button) {
      return;
    }
    event.preventDefault();

    var quickbuyEl = document.querySelector('drawer-quickbuy');
    if (quickbuyEl && typeof quickbuyEl.openDrawer === 'function') {
      quickbuyEl.openDrawer({ currentTarget: button });
    }
  });
})();
